import { useCallback } from 'react'

import { filter } from 'lodash'
import { useSelector } from 'react-redux'

import { useIsAuthed } from 'components/AuthShield'
import { selectCareerTitles } from 'store/career-titles'

import { types } from '../../../../../AwesomeBar'
import ResultComponent from './ResultComponent'

interface ITitle {
  Title: string
  SOC: string
  Cluster: string
}

export const label = 'Careers'

const RESULT_COUNT_MAX = 20

const getResult = ({ Title, SOC, Cluster }: ITitle) => ({
  searchTypeLabel: label,
  label: Title,
  name: Title,
  soc: SOC,
  cluster: Cluster,
})

export const careerTitleSearch = (term: string, titles: any[]) => {
  const sanitizedTerm = term.replace(/[^a-zA-Z0-9 ]/g, '')
  const filterFn = ({ Title }: ITitle) => new RegExp(`\\b${sanitizedTerm}`, 'gi').test(Title)
  const results = filter(titles, filterFn).slice(0, RESULT_COUNT_MAX).map(getResult)

  return results
}

export const useCareersSearchConfig = (): types.ISearchConfiguration => {
  const isAuthed = useIsAuthed()
  const careerTitles = useSelector(selectCareerTitles)

  const search = useCallback(
    (term: string) => {
      return new Promise((resolve) => {
        resolve(careerTitleSearch(term, careerTitles))
      })
    },
    [careerTitles],
  )

  return {
    label,
    search,
    ResultComponent,
    allLimit: 20,
    placeholderOption: 'Search for careers',
    hidden: !isAuthed,
  }
}
